module.exports = {
    // baseurl: "https://rider.goone.club",
    baseurl2: "https://api.khealth.in",
    baseurl3: "https://api.khealth.in",
    baseurl4: "https://food.goone.club",
    baseurl5: "https://homeservice.goone.club/",
    baseurl6:"https://grocery.goone.club",
    baseurl: "https://api.khealth.in"
}
